import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, ArrowUpRightIcon } from 'lucide-react';
import { twMerge } from 'tailwind-merge';
type Variant = 'primary' | 'secondary' | 'quiet';
type Size = 'sm' | 'md';
interface ButtonLinkProps {
  to?: string;
  href?: string;
  variant?: Variant;
  size?: Size;
  icon?: 'arrow' | 'external' | null;
  className?: string;
  children: React.ReactNode;
}
const base = 'group inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-full font-medium transition-[background-color,color,box-shadow,transform] duration-150 ease-out active:scale-[0.98] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/40 focus-visible:ring-offset-2 focus-visible:ring-offset-canvas';
const variants: Record<Variant, string> = {
  primary: 'bg-accent text-white hover:bg-accent-ink shadow-[0_8px_24px_-10px_rgba(43,91,232,0.7)]',
  secondary: 'glass text-ink hover:bg-white',
  quiet: 'text-accent hover:text-accent-ink'
};
const sizes: Record<Size, string> = {
  sm: 'h-9 px-4 text-sm',
  md: 'h-11 px-5 text-[15px]'
};
export function ButtonLink({
  to,
  href,
  variant = 'primary',
  size = 'md',
  icon = null,
  className,
  children
}: ButtonLinkProps) {
  const classes = twMerge(base, variants[variant], variant === 'quiet' ? 'h-auto px-0 text-[15px]' : sizes[size], className);
  const iconEl = icon === 'arrow' ? <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-472" data-mp="24r36q7wl8cfa" /> : icon === 'external' ? <ArrowUpRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:-translate-y-px group-hover:translate-x-px" aria-hidden="true" data-id="element-473" data-mp="2eo7ycn97d03h" /> : null;
  if (href) {
    return <a href={href} target="_blank" rel="noopener noreferrer" className={classes} data-id="element-474" data-mp="3q34xipz3p5ok">
        {children}
        {iconEl}
        <span className="sr-only" data-id="element-475" data-mp="3l3iaxpxdud33">(opens in a new tab)</span>
      </a>;
  }
  return <Link to={to ?? '/'} className={classes} data-id="element-476" data-mp="3t60z170xjb3a">
      {children}
      {iconEl}
    </Link>;
}